import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { navigationUrl } from '../../../store/analytic/actions';

import Modal from '../index';
import FillCPF from '../InfoToModal/FillCPF';

interface IReceiveCall {
  handlerClose: () => void;
  verification: string;
}

const ReceiveCallModal: React.FC<IReceiveCall> = (props) => {
  const [title, setTitle] = useState('Receber uma ligação');
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      navigationUrl.request({
        action: '/abreReceberLigacaoAgora',
      }),
    );
  }, [dispatch]);

  const handleChangeTitle = () => {
    setTitle('');
  };

  return (
    <Modal
      title={title}
      handlerClose={props.handlerClose}
      width={
        window.matchMedia('(max-width: 960px)').matches ? '360px' : '464px'
      }
    >
      <FillCPF
        title={'Preencha seu CPF abaixo para que possamos saber quem você é:'}
        subtitle={'Seu CPF:'}
        handlerClose={props.handlerClose}
        changeTitle={handleChangeTitle}
        textbtn={'RECEBER LIGAÇÃO'}
        text2btn={'AGORA'}
        type={'ReceberLigacao'}
        verification={props.verification}
        details={{
          title: 'Já vamos te ligar!',
          subtitle:
            'Assim que um de nossos operadores estiver dispopnível você receberá nossa ligação.',
          detail: '',
          datehour: '',
        }}
      />
    </Modal>
  );
};

export default ReceiveCallModal;
